/**
 * HDMI output mode ("3840x2160@60") helpers. A refresh rate of 59.x counts as 60
 * (59.94 is the NTSC flavour of 60) -- mirrors the backend infoReasons() rule.
 */
export function hdmiRefreshHz(mode) {
  if (typeof mode !== 'string') return null;
  const m = mode.match(/^\s*\d{3,5}\s*x\s*\d{3,5}\s*[a-z]?\s*@\s*(\d{1,3}(?:\.\d+)?)\s*$/i);
  return m ? Number(m[1]) : null;
}

/** true => show the small warning badge (parsed, and not ~60 Hz). Unknown / unparsable => false. */
export function hdmiNotSixty(mode) {
  const hz = hdmiRefreshHz(mode);
  return hz !== null && !(hz >= 59 && hz < 60.5);
}
